import React from "react";
import {
  List,
  Datagrid,
  DateInput,
  TextField,
  Filter,
  TextInput,
  ReferenceInput,
  SelectInput,
  FunctionField
} from "react-admin";
import { useStore } from "react-redux";
import _ from "lodash";
import {
  DEFAULT_START_DATE,
  DEFAULT_END_DATE
} from "../data/providers/graphQLDataProviderV2/utils";
import { formatName, parseName } from "util/misc";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { CustomGameStatusField } from "../fields/CustomGamesStatusField";

const GameFilter = (props) => {
  const store = useStore();
  const sportCode = _.get(
    store.getState(),
    "admin.resources.games.list.params.filter.sportCode",
    ""
  );

  return (
    <Filter {...props}>
      <TextInput
        label="School Name"
        source="name"
        format={(v) => formatName(v)}
        parse={(v) => parseName(v)}
        alwaysOn
      />
      <ReferenceInput
        label="Sport"
        source="sportCode"
        reference="sportCodes"
        alwaysOn
      >
        <SelectInput optionText="label" optionValue="code" />
      </ReferenceInput>
      <ReferenceInput
        label="Season"
        source="seasonCode"
        reference="availableSeasons"
        filter={{ sportCode }}
        alwaysOn
      >
        <SelectInput optionText="label" optionValue="code" />
      </ReferenceInput>
      <SelectInput
        label="Top Game"
        source="isTopGame"
        choices={[
          { id: "NO SHOW", name: "Show All" },
          { id: true, name: "Show Only Top Games" },
          { id: false, name: "Show All Except Top Games" }
        ]}
        alwaysOn
      />
      <DateInput
        label="From Date"
        source="startDate"
        initialValue={DEFAULT_START_DATE}
        alwaysOn
      />
      <DateInput
        label="To Date"
        source="endDate"
        initialValue={DEFAULT_END_DATE}
        alwaysOn
      />
    </Filter>
  );
};

const dateDisplay = (record) => {
  if (!record.gameDate) return;
  const zonedTime = utcToZonedTime(record.gameDate, "America/Chicago");
  if (record.gameTimeString) {
    return format(zonedTime, "MM/dd/yy, h:mm aa");
  } else {
    return format(zonedTime, "MM/dd/yy");
  }
};

const scoreDisplay = (record) => {
  const map = {
    football: "football.totalPoints",
    "girls-volleyball": "girlsvolleyball.finalScore",
    "girls-basketball": "basketball.totalPoints",
    "boys-basketball": "basketball.totalPoints",
    "girls-soccer": "soccer.totalGoals",
    "boys-soccer": "soccer.totalGoals",
    baseball: "baseball.runs",
    softball: "baseball.runs"
  };
  const sportCode = _.get(record, "sportCode");
  const scorePath = _.get(map, sportCode);
  const homeScore = _.get(record, `home.${scorePath}`, 0) || 0;
  const awayScore = _.get(record, `away.${scorePath}`, 0) || 0;
  return homeScore || awayScore ? `${awayScore}-${homeScore}` : null;
};

const GameList = (props) => (
  <List {...props} bulkActionButtons={false} filters={<GameFilter />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <FunctionField label="Date" render={(record) => dateDisplay(record)} />
      <TextField source="away.season.team.school.name" label="Away School" />
      <FunctionField label="Score" render={(record) => scoreDisplay(record)} />
      <TextField source="home.season.team.school.name" label="Home school" />
      <CustomGameStatusField source="gameStatus" label="Is Final" />
    </Datagrid>
  </List>
);

export default GameList;
